/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Assistant_Activity_More_ChangesInputs */



/**
* | output |
* | --- |
* | "{count} more changes not shown" |
*
* @param {Assistant_Activity_More_ChangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_more_changes = /** @type {((inputs: Assistant_Activity_More_ChangesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_More_ChangesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} autres modifications non affichées`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Weitere Änderungen werden nicht angezeigt`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} ulteriori modifiche non mostrate`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} другие изменения не показаны`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} No se muestran más cambios`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 更多变化未显示`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} その他の変更は表示されていません`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} में और बदलाव नहीं दिखाए गए हैं`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} mais alterações não mostradas`)
	return /** @type {LocalizedString} */ (`${i?.count} more changes not shown`)
});